import { render, staticRenderFns } from "./StartupTags.vue?vue&type=template&id=20406bc2&scoped=true&"
import script from "./StartupTags.vue?vue&type=script&lang=js&"
export * from "./StartupTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20406bc2",
  null
  
)

export default component.exports